(() => {
  'use strict';

  if (window.__STRYKR_KACHING_ATC_20260528__) return;
  window.__STRYKR_KACHING_ATC_20260528__ = true;

  const BUTTON_SELECTOR = '[data-strykr-kaching-atc], #cta-main, [id^="ProductSubmitButton-"]';
  const BUTTON_CLASS = 'strykr-kaching-atc-button';
  const KACHING_ZONE_SELECTOR = '#strykr-pricing-zone, #strykr-commerce-zone, .kaching-mount, .commerce-zone, kaching-bundle, kaching-bundles-block';

  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const normalize = (value) => String(value || '').trim().toLowerCase();
  const parseJson = (value, fallback = null) => {
    try {
      return JSON.parse(value || 'null') || fallback;
    } catch (_) {
      return fallback;
    }
  };
  const parseAttr = (node, attr, fallback = null) => node ? parseJson(node.getAttribute(attr), fallback) : fallback;

  const findScope = (node) => {
    if (node && node.closest) {
      return node.closest('[data-strykr-main-product], section[id^="MainProduct-"], product-info, .main-product__info-container, .product__info-container') || document;
    }
    return document;
  };

  const findKachingBlock = (scope = document) => {
    // PATCH 20260519: pas de fallback document.querySelector — sinon un bouton ATC hors widget bundle
    // hérite quand même du block global et pollue les ajouts non-bundle avec les properties Kaching.
    // Aussi : on rejette scope === document (fallback de findScope) pour éviter le même piège.
    if (!scope || scope === document) return null;
    return scope.querySelector('kaching-bundles-block');
  };

  const findKachingZone = (scope = document) => {
    return scope.querySelector(KACHING_ZONE_SELECTOR)
      || document.querySelector(KACHING_ZONE_SELECTOR);
  };

  const getKachingProduct = (block) => {
    const blockProduct = parseAttr(block, 'product');
    if (blockProduct) return blockProduct;

    const productId = block && (block.getAttribute('product-id') || parseJson(block.getAttribute('config'), {})?.productId);
    const script = productId
      ? document.querySelector(`script.kaching-bundles-product[data-product-id="${CSS.escape(String(productId))}"]`)
      : document.querySelector('script.kaching-bundles-product[data-main="true"], script.kaching-bundles-product[data-product-id]');
    return parseJson(script && script.textContent, {}) || {};
  };

  const getDealBlock = (block) => parseAttr(block, 'deal-block', {}) || {};

  const allowPreselectedDeal = (scope) => {
    return Boolean(scope && scope !== document && scope.querySelector('[data-strykr-kaching-preselected-ok]'));
  };

  const getSelectValue = (select) => {
    const option = select && select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    const value = select && select.value ? String(select.value).trim() : '';
    const label = option && option.textContent ? option.textContent.trim() : '';
    return value || label;
  };

  const getKachingOptionValue = (node) => {
    if (!node) return '';
    if (node.tagName === 'SELECT') return getSelectValue(node);
    if (node.dataset && node.dataset.value) return String(node.dataset.value).trim();
    const selectedOption = node.querySelector && node.querySelector('option:checked, [aria-selected="true"], [data-selected="true"]');
    if (selectedOption) {
      return String(selectedOption.value || selectedOption.dataset.value || selectedOption.textContent || '').trim();
    }
    return String(node.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const variantIdFromValue = (value) => {
    const raw = String(value || '').trim();
    const gidMatch = raw.match(/ProductVariant\/(\d+)$/);
    if (gidMatch) return gidMatch[1];
    return /^\d{8,}$/.test(raw) ? raw : '';
  };

  const getSelectedDeal = (scope, block) => {
    // PATCH 20260519: par défaut, ne renvoyer un deal QUE si un radio est explicitement coché dans le scope local.
    // Pas de fallback sur preselectedDealBarId (qui est l'auto-pre-sélection Kaching),
    // pas de fallback sur document.querySelector (autre block sur la page).
    // PATCH belt: la PDP ceinture autorise le fallback preselected uniquement via data-strykr-kaching-preselected-ok.
    const dealBlock = getDealBlock(block);
    const checked = (scope || document).querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    const selectedId = checked && checked.value ? checked.value : (allowPreselectedDeal(scope) ? dealBlock.preselectedDealBarId : '');
    if (!selectedId) return null;
    if (!Array.isArray(dealBlock.dealBars)) return null;
    return dealBlock.dealBars.find((deal) => String(deal.id) === String(selectedId)) || null;
  };

  const getSelectedOptions = (scope, product) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    const selects = Array.from((scope || document).querySelectorAll('select.kaching-bundles-option, .kaching-bundles__bar-variant-select'));
    if (!selects.length) return [];

    if (optionNames.length) {
      const byName = new Map();
      selects.forEach((select) => {
        const name = select.dataset && select.dataset.name;
        if (!name) return;
        const key = normalize(name);
        if (!byName.has(key)) byName.set(key, getSelectValue(select));
      });
      const ordered = optionNames.map((name) => byName.get(normalize(name)));
      if (ordered.every(Boolean)) return ordered;
    }

    return selects.slice(0, optionNames.length || selects.length).map(getSelectValue).filter(Boolean);
  };

  const getSelectedDealBar = (scope, selectedDeal) => {
    // PATCH 20260519: suppression des fallbacks document.querySelector pour rester strictement
    // dans le scope local (sinon on retombe sur le widget Kaching global d'une autre instance).
    if (!scope || scope === document) return null;
    const checked = scope.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    const selectedId = checked && checked.value ? checked.value : selectedDeal && selectedDeal.id;

    if (checked) {
      const bar = checked.closest('.kaching-bundles__bar, [data-deal-bar-id]');
      if (bar) return bar;
    }

    if (!selectedId) return null;
    return scope.querySelector(`[data-deal-bar-id="${CSS.escape(String(selectedId))}"]`);
  };

  const getSelectedOptionSets = (scope, product, selectedDeal) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    const optionCount = optionNames.length || 1;
    const selectedBar = getSelectedDealBar(scope, selectedDeal);

    if (scope && scope.querySelector && scope.querySelector('#strykr-commerce-zone[data-strykr-kaching-preselected-ok]') && selectedBar && optionNames.length) {
      const rowOptionSets = Array.from(selectedBar.querySelectorAll('.kaching-bundles__bar-variant'))
        .map((row) => {
          const byName = new Map();
          Array.from(row.querySelectorAll('.kaching-bundles-option[data-name]')).forEach((node) => {
            const name = node.dataset && node.dataset.name;
            const value = getKachingOptionValue(node);
            if (name && value) byName.set(normalize(name), value);
          });
          const ordered = optionNames.map((name) => byName.get(normalize(name)));
          return ordered.every(Boolean) ? ordered : [];
        })
        .filter((selectedOptions) => selectedOptions.length === optionNames.length);

      if (rowOptionSets.length) return rowOptionSets;
    }

    const selects = selectedBar
      ? Array.from(selectedBar.querySelectorAll('select.kaching-bundles-option, .kaching-bundles__bar-variant-select'))
      : [];

    if (!selects.length) {
      const fallbackOptions = getSelectedOptions(scope, product);
      return fallbackOptions.length ? [fallbackOptions] : [];
    }

    const optionSets = [];
    for (let index = 0; index < selects.length; index += optionCount) {
      const group = selects.slice(index, index + optionCount);
      if (group.length < optionCount) continue;

      if (optionNames.length) {
        const byName = new Map();
        group.forEach((select) => {
          const name = select.dataset && select.dataset.name;
          if (!name) return;
          byName.set(normalize(name), getSelectValue(select));
        });
        const ordered = optionNames.map((name) => byName.get(normalize(name)));
        if (ordered.every(Boolean)) {
          optionSets.push(ordered);
          continue;
        }
      }

      optionSets.push(group.map(getSelectValue).filter(Boolean));
    }

    return optionSets;
  };

  const findVariantByOptions = (product, selectedOptions) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const selectedVariantId = selectedOptions.map(variantIdFromValue).find(Boolean);
    if (selectedVariantId) {
      const matchedById = variants.find((candidate) => String(candidate.id) === String(selectedVariantId));
      if (matchedById && matchedById.id) return matchedById;
    }

    if (selectedOptions.length) {
      const matched = variants.find((candidate) => {
        const options = Array.isArray(candidate.options) ? candidate.options : [];
        return selectedOptions.every((option, index) => normalize(options[index]) === normalize(option));
      });
      if (matched && matched.id) return matched;
    }

    return null;
  };

  const findVariant = (scope, product) => {
    const selectedOptions = getSelectedOptions(scope, product);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const matched = findVariantByOptions(product, selectedOptions);
    if (matched) return matched;

    const selectedId = product.selectedVariantId || product.selected_variant_id;
    return variants.find((candidate) => String(candidate.id) === String(selectedId))
      || variants.find((candidate) => candidate.availableForSale !== false && candidate.available !== false)
      || variants[0]
      || null;
  };

  const productIdFromGID = (gid) => {
    const match = String(gid || '').match(/Product\/(\d+)$/);
    return match ? match[1] : '';
  };

  const getKachingProductById = (productId) => {
    if (!productId) return {};
    const script = document.querySelector(`script.kaching-bundles-product[data-product-id="${CSS.escape(String(productId))}"]`);
    return parseJson(script && script.textContent, {}) || {};
  };

  const getNodeOptionValue = (node) => {
    if (!node) return '';
    if (node.tagName === 'SELECT' && node.value) return node.value;
    if (node.dataset && node.dataset.value) return node.dataset.value;
    const selectedOption = node.querySelector && node.querySelector('option:checked, [aria-selected="true"], [data-selected="true"]');
    return selectedOption ? (selectedOption.value || selectedOption.dataset.value || selectedOption.textContent || '').trim() : '';
  };

  const getSelectedOptionsFromUpsell = (upsellNode, product) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    if (!optionNames.length || !upsellNode) return [];

    const byName = new Map();
    Array.from(upsellNode.querySelectorAll('.kaching-bundles-option[data-name]')).forEach((node) => {
      const name = node.dataset && node.dataset.name;
      if (!name) return;
      const key = normalize(name);
      if (byName.has(key)) return;
      const value = getNodeOptionValue(node);
      if (value) byName.set(key, value);
    });

    const ordered = optionNames.map((name) => byName.get(normalize(name)));
    return ordered.every(Boolean) ? ordered : [];
  };

  const getVariantIdFromUpsellLink = (upsellNode) => {
    const link = upsellNode && upsellNode.querySelector('a[href*="variant="]');
    if (!link) return '';
    try {
      return new URL(link.getAttribute('href'), window.location.origin).searchParams.get('variant') || '';
    } catch (_) {
      return '';
    }
  };

  const isUpsellSelected = (upsellNode) => {
    const checkbox = upsellNode && upsellNode.querySelector('.kaching-bundles__upsell__checkbox');
    if (!checkbox) return false;
    return checkbox.classList.contains('kaching-bundles__upsell__checkbox--selected')
      || checkbox.getAttribute('aria-checked') === 'true'
      || checkbox.dataset.selected === 'true';
  };

  const hasSelectedUpsells = (scope, selectedDeal) => {
    const selectedBar = getSelectedDealBar(scope, selectedDeal);
    if (!selectedBar || !selectedDeal || !Array.isArray(selectedDeal.upsells)) return false;
    const configuredIds = new Set(
      selectedDeal.upsells
        .filter((upsell) => upsell && upsell.id)
        .map((upsell) => String(upsell.id))
    );

    return Array.from(selectedBar.querySelectorAll('.kaching-bundles__upsell[data-upsell-id]'))
      .some((upsellNode) => configuredIds.has(String(upsellNode.dataset.upsellId)) && isUpsellSelected(upsellNode));
  };

  const collectSelectedUpsellItems = (scope, selectedDeal, itemWithProps) => {
    const selectedBar = getSelectedDealBar(scope, selectedDeal);
    if (!selectedBar || !selectedDeal || !Array.isArray(selectedDeal.upsells)) return [];

    const upsellById = new Map(
      selectedDeal.upsells
        .filter((upsell) => upsell && upsell.id)
        .map((upsell) => [String(upsell.id), upsell])
    );

    return Array.from(selectedBar.querySelectorAll('.kaching-bundles__upsell[data-upsell-id]'))
      .map((upsellNode) => {
        if (!isUpsellSelected(upsellNode)) return null;

        const config = upsellById.get(String(upsellNode.dataset.upsellId));
        if (!config) return null;

        const product = getKachingProductById(productIdFromGID(config.productGID));
        const selectedOptions = getSelectedOptionsFromUpsell(upsellNode, product);
        const variant = findVariantByOptions(product, selectedOptions);
        const variantId = variant && variant.id ? variant.id : getVariantIdFromUpsellLink(upsellNode);
        if (!variantId) return null;

        return itemWithProps({
          id: Number(variantId),
          quantity: Number(config.quantity) || 1
        });
      })
      .filter(Boolean);
  };

  const findExistingProperty = (scope, name) => {
    // PATCH 20260519: suppression du fallback document.querySelector pour ne pas réutiliser
    // une session_id d'un autre widget Kaching présent sur la page.
    if (!scope || scope === document) return '';
    const escaped = CSS.escape(`properties[${name}]`);
    const input = scope.querySelector(`input[name="${escaped}"]`);
    return input && input.value ? input.value : '';
  };

  const buildKachingProperties = (scope, block, selectedDeal) => {
    // PATCH 20260520: BUG C — Toujours générer une nouvelle session_id pour un nouvel ajout
    // ATC. Réutiliser une session existante (trouvée via findExistingProperty) causait
    // le regroupement erroné d'articles individuels dans des bundles précédents,
    // propageant des remises indues (ex: 59€ -> 50.92€).
    if (!selectedDeal || !selectedDeal.id) return null;

    const dealBlock = getDealBlock(block);
    const bundleValue = JSON.stringify({
      deal: dealBlock.nanoId || dealBlock.id || (block && block.getAttribute('deal-block-id')) || '',
      main: true,
      bid: selectedDeal.id,
      ab: dealBlock.abTestVariantNumber === 2 ? 'B' : 'A'
    });

    const sessionId = (window.crypto && typeof window.crypto.randomUUID === 'function')
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    return {
      __kaching_bundles: bundleValue,
      __kaching_session_id: sessionId
    };
  };

  const getKachingBundleProperty = (item) => {
    const raw = item && item.properties && item.properties.__kaching_bundles;
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  };

  const shouldMergeKachingFormProperties = (item) => {
    const bundle = getKachingBundleProperty(item);
    return !bundle || Boolean(bundle.main) || Boolean(bundle.collectionBreaksProduct);
  };

  const collectKachingFormProperties = (scope) => {
    if (!scope || scope === document) return {};
    const entries = Array.from(scope.querySelectorAll('[name^="properties"]'))
      .map((node) => {
        const match = String(node.name || '').match(/^properties\[(.*)\]$/);
        return match ? [match[1], node.value] : null;
      })
      .filter((entry) => entry && entry[0] && entry[0] !== '__kaching_bundles');

    return Object.fromEntries(entries);
  };

  const cloneCartItem = (item) => {
    const clone = {
      id: item.id,
      quantity: item.quantity
    };
    if (item.properties) clone.properties = Object.assign({}, item.properties);
    if (item.selling_plan) clone.selling_plan = item.selling_plan;
    if (item.parent_id) clone.parent_id = item.parent_id;
    return clone;
  };

  const getNativeKachingItems = (scope, block) => {
    if (!block || typeof block.items !== 'function') return [];
    let items = [];
    try {
      items = block.items();
    } catch (_) {
      return [];
    }
    if (!Array.isArray(items) || !items.length) return [];

    const formProperties = collectKachingFormProperties(scope);
    return items.map((item) => {
      const clone = cloneCartItem(item);
      if (shouldMergeKachingFormProperties(clone)) {
        clone.properties = Object.assign({}, formProperties, clone.properties || {});
      }
      return clone;
    });
  };

  const buildPayload = (button) => {
    const scope = findScope(button);
    const block = findKachingBlock(scope);
    const product = getKachingProduct(block);
    const selectedDeal = getSelectedDeal(scope, block);
    const quantity = Number(selectedDeal && selectedDeal.quantity) || 1;
    const selectedUpsells = hasSelectedUpsells(scope, selectedDeal);

    if (selectedUpsells) {
      const nativeItems = getNativeKachingItems(scope, block);
      if (!nativeItems.length) throw new Error('Kaching payload native introuvable.');
      return { items: nativeItems, kachingNative: true };
    }

    // Intercepter aussi l'offre 1 article évite la soumission native vers /cart.
    // Mais les propriétés Kaching restent réservées aux vrais bundles (2+ articles),
    // sinon Shopify/Kaching peut appliquer une remise bundle au produit seul.
    const properties = quantity >= 2 ? buildKachingProperties(scope, block, selectedDeal) : null;
    const optionSets = getSelectedOptionSets(scope, product, selectedDeal);
    // PATCH 20260519: helper pour n'ajouter `properties` que si non-null (sinon Shopify Cart API
    // peut interpréter properties=null comme un objet vide ou rejeter selon les cas).
    const itemWithProps = (base) => properties ? Object.assign({}, base, { properties }) : base;

    const items = optionSets
      .slice(0, quantity)
      .map((selectedOptions) => {
        const variant = findVariantByOptions(product, selectedOptions);
        if (!variant || !variant.id) return null;
        return itemWithProps({ id: Number(variant.id), quantity: 1 });
      })
      .filter(Boolean);

    if (!items.length) {
      const variant = findVariant(scope, product);
      if (!variant || !variant.id) {
        throw new Error('Variante introuvable depuis Kaching.');
      }
      items.push(itemWithProps({ id: Number(variant.id), quantity }));
    }

    const upsellItems = collectSelectedUpsellItems(scope, selectedDeal, itemWithProps);
    if (upsellItems.length) items.push(...upsellItems);

    return { items };
  };

  const stableJson = (value) => {
    if (!value || typeof value !== 'object') return '';
    return JSON.stringify(Object.keys(value).sort().reduce((acc, key) => {
      acc[key] = value[key];
      return acc;
    }, {}));
  };

  const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  const readJsonResponse = async (response) => {
    const text = await response.text();
    try {
      return text ? JSON.parse(text) : {};
    } catch (_) {
      return {};
    }
  };

  const normalizeCartAddLines = (payload) => {
    const rawItems = Array.isArray(payload && payload.items) ? payload.items : [payload].filter(Boolean);
    const grouped = new Map();

    rawItems.forEach((item) => {
      if (!item || !item.id) return;
      const quantity = Math.max(1, Number(item.quantity) || 1);
      const propertiesKey = stableJson(item.properties);
      const sellingPlan = item.selling_plan || item.sellingPlan || '';
      const parentId = item.parent_id || item.parentId || '';
      const key = [item.id, quantity > 0 ? propertiesKey : '', sellingPlan, parentId].join('::');
      const existing = grouped.get(key);
      if (existing) {
        existing.quantity += quantity;
      } else {
        const rawId = String(item.id).trim();
        const line = {
          id: /^\d+$/.test(rawId) ? Number(rawId) : rawId,
          quantity
        };
        if (item.properties) line.properties = item.properties;
        if (sellingPlan) line.selling_plan = sellingPlan;
        if (item.parent_id || item.parentId) line.parent_id = item.parent_id || item.parentId;
        grouped.set(key, line);
      }
    });

    return Array.from(grouped.values());
  };

  const fetchCart = async () => {
    const response = await fetch(`${rootPath()}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    const json = await readJsonResponse(response);
    if (!response.ok) throw new Error(json.description || json.message || response.statusText);
    return json;
  };

  const restoreCart = async (snapshot) => {
    if (!snapshot || !Array.isArray(snapshot.items)) return;

    const beforeByKey = new Map(snapshot.items.map((item) => [item.key, item.quantity]));
    const current = await fetchCart();
    const lines = Array.isArray(current.items) ? current.items : [];

    for (const line of lines) {
      if (!line || !line.key) continue;
      const targetQuantity = beforeByKey.has(line.key) ? beforeByKey.get(line.key) : 0;
      if (line.quantity === targetQuantity) continue;

      const response = await fetch(`${rootPath()}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: line.key, quantity: targetQuantity })
      });
      const json = await readJsonResponse(response);
      if (!response.ok) throw new Error(json.description || json.message || response.statusText);
    }
  };

  const addCartLine = async (line, attempt = 0) => {
    const response = await fetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(line)
    });
    const json = await readJsonResponse(response);

    if (!response.ok) {
      const retryable = [409, 429, 503].includes(response.status);
      if (retryable && attempt < 1) {
        await sleep(280 + Math.round(Math.random() * 220));
        return addCartLine(line, attempt + 1);
      }
      throw new Error(json.description || json.message || response.statusText);
    }

    return json;
  };

  const addKachingCartItems = async (lines, attempt = 0) => {
    const response = await fetch(`${rootPath()}cart/add.js?kaching_bundles=true`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Kaching-Cart-Ignore': '1'
      },
      body: JSON.stringify({ items: lines })
    });
    const json = await readJsonResponse(response);

    if (!response.ok) {
      const retryable = [409, 429, 503].includes(response.status);
      if (retryable && attempt < 1) {
        await sleep(280 + Math.round(Math.random() * 220));
        return addKachingCartItems(lines, attempt + 1);
      }
      throw new Error(json.description || json.message || response.statusText);
    }

    return json;
  };

  const cartAddViaTopWindow = async (payload) => {
    const lines = normalizeCartAddLines(payload);
    if (!lines.length) throw new Error('Keine Warenkorb-Zeile gefunden.');

    const beforeCart = await fetchCart();
    const responses = [];

    try {
      if (payload && payload.kachingNative) {
        const batchResponse = await addKachingCartItems(lines);
        if (Array.isArray(batchResponse.items)) responses.push(...batchResponse.items);
        else responses.push(batchResponse);
      } else {
        for (const line of lines) {
          responses.push(await addCartLine(line));
        }
      }
    } catch (error) {
      try {
        await restoreCart(beforeCart);
        await updateCartCount();
      } catch (rollbackError) {
        console.warn('[STRYKR] Kaching ATC rollback failed', rollbackError);
      }
      throw error;
    }

    return { items: responses, item_count: responses.length };
  };

  const ensureDrawerElement = () => {
    if (typeof window.removeTrapFocus !== 'function') window.removeTrapFocus = () => {};
    if (typeof window.trapFocus !== 'function') window.trapFocus = () => {};
    if (!window.customElements || window.customElements.get('cart-drawer')) return;

    window.customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      connectedCallback() {
        const overlay = this.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
        if (overlay && overlay.dataset.strykrDrawerBound !== 'true') {
          overlay.dataset.strykrDrawerBound = 'true';
          overlay.addEventListener('click', () => this.close());
        }
      }

      open() {
        this.classList.add('active');
        this.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
  };

  const sectionUrl = (ids) => {
    const url = new URL(rootPath(), window.location.origin);
    url.searchParams.set('sections', ids.join(','));
    return url.toString();
  };

  const replaceSection = (id, html) => {
    if (!html) return;
    const parser = new DOMParser();
    const nextDoc = parser.parseFromString(html, 'text/html');
    const next = nextDoc.getElementById(`shopify-section-${id}`) || nextDoc.getElementById(id);
    const current = document.getElementById(`shopify-section-${id}`) || document.getElementById(id);
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const refreshDrawer = async () => {
    try {
      const response = await fetch(sectionUrl(['cart-drawer', 'cart-icon-bubble']), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const sections = await response.json();
      replaceSection('cart-drawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
    } catch (_) {}
  };

  const openDrawer = async () => {
    ensureDrawerElement();
    await refreshDrawer();
    ensureDrawerElement();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (drawer) {
      drawer.classList.add('active');
      drawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
    }
  };

  const updateCartCount = async () => {
    try {
      const cart = await fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-count').forEach((node) => {
        node.textContent = String(cart.item_count);
      });

      // Bug B: refresh drawer if bubble is missing
      const bubbleContainer = document.getElementById('cart-icon-bubble');
      if (bubbleContainer && cart.item_count > 0 && !bubbleContainer.querySelector('.cart-count-bubble')) {
        await refreshDrawer();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
      return cart;
    } catch (_) {
      return null;
    }
  };

  const setButtonState = (button, state) => {
    if (!button) return;
    const text = button.querySelector('[data-cta-text], .main-atc__label__text, .button__label') || button;
    if (!button.dataset.defaultText) button.dataset.defaultText = text.textContent.trim() || 'Jetzt in den Warenkorb';

    if (state === 'loading') {
      button.disabled = true;
      text.textContent = 'Wird hinzugefügt...';
    } else if (state === 'added') {
      text.textContent = 'Hinzugefügt ✓';
    } else if (state === 'error') {
      text.textContent = 'Fehler · erneut versuchen';
    } else {
      button.disabled = false;
      text.textContent = button.dataset.defaultText || 'Jetzt in den Warenkorb';
    }
  };

  const addToCart = async (button) => {
    if (!button || button.dataset.strykrAdding === 'true') return;
    button.dataset.strykrAdding = 'true';
    setButtonState(button, 'loading');

    try {
      const payload = buildPayload(button);
      const added = await cartAddViaTopWindow(payload);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: added }));
      await updateCartCount();
      setButtonState(button, 'added');
      await openDrawer();
      window.setTimeout(() => {
        delete button.dataset.strykrAdding;
        setButtonState(button, 'idle');
      }, 350);
    } catch (error) {
      console.warn('[STRYKR] Kaching ATC failed', error);
      setButtonState(button, 'error');
      window.setTimeout(() => {
        delete button.dataset.strykrAdding;
        setButtonState(button, 'idle');
      }, 1600);
    }
  };

  const injectStyles = () => {
    if (document.getElementById('strykr-kaching-atc-style')) return;
    const style = document.createElement('style');
    style.id = 'strykr-kaching-atc-style';
    style.textContent = `
      .${BUTTON_CLASS} {
        width: 100%;
        min-height: 58px;
        border: 0;
        border-radius: 0;
        background: #ff5a1f;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 16px 22px;
        font: inherit;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
        cursor: pointer;
        transition: transform .18s ease, filter .18s ease, opacity .18s ease;
      }
      .${BUTTON_CLASS}:hover { filter: brightness(.95); transform: translateY(-1px); }
      .${BUTTON_CLASS}:disabled { cursor: wait; opacity: .78; transform: none; }
    `;
    document.head.appendChild(style);
  };

  const createButton = (scope) => {
    const zone = findKachingZone(scope);
    if (!zone) return;
    const localScope = findScope(zone);
    if (localScope.querySelector(BUTTON_SELECTOR)) return;
  };

  const bind = () => {
    injectStyles();
    document.querySelectorAll('kaching-bundles-block, #strykr-pricing-zone, #strykr-commerce-zone, .kaching-mount, .commerce-zone').forEach((node) => {
      createButton(findScope(node));
    });
  };

  // PATCH 20260519: helper d'éligibilité — n'intercepter que si on a un block Kaching local
  // ET un deal sélectionné (ou preselected autorisé côté ceinture). Sinon on laisse le handler natif (strykr-product-atc)
  // traiter l'ajout sans properties Kaching, évitant de polluer un ajout "normal".
  const shouldHandleAsKachingBundle = (scope) => {
    const block = findKachingBlock(scope);
    if (!block) return false;
    const deal = getSelectedDeal(scope, block);
    if (!deal || !deal.id) return false;
    // PATCH 20260528 : on intercepte aussi le deal 1 article en AJAX pour empêcher
    // la redirection native vers /cart. buildPayload() n'attache les properties
    // Kaching qu'aux vrais bundles (quantity >= 2), donc on ne réintroduit pas
    // le bug de remise sur le produit seul.
    const qty = Number(deal.quantity);
    return Number.isFinite(qty) && qty >= 1;
  };

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    const scope = findScope(button);
    if (!shouldHandleAsKachingBundle(scope)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(button);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!form) return;
    const scope = findScope(form);
    if (!shouldHandleAsKachingBundle(scope)) return;
    const button = form.querySelector(BUTTON_SELECTOR) || scope.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(button);
  }, true);

  ready(() => {
    bind();
    const observer = new MutationObserver(bind);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
